export const servicesTypes = [
	{
		id: '01',
		identifier: 'CREATE_GARDEN',
		label: 'Crear jardín desde 0',
		subLabel: '',
		question: '¿Sábes qué quieres?',
		step1types: [
			{
				step1typeId: '01-01',
				identifier: 'YES',
				label: 'Sí',
				subLabel: '¡Tengo una idea de lo que quiero!',
				question: '¿Tienes ya un diseño?',
				step2types: [
					{
						step2typeId: '01-01-01',
						identifier: 'YES',
						label: 'Sí',
						subLabel: 'Tengo mi propio diseño',
						question: 'Completa toda la información que puedas',
						inputs: [
							{
								inputId: '01-01-01-01',
								identifier: 'DESIGN',
								label: 'Diseño',
								caption: 'Adjunta tu diseño en .pdf',
								placeholder: 'Selecciona un documento',
								type: 'attachment',
							},
							{
								inputId: '01-01-01-02',
								identifier: 'WEATHER',
								label: 'Clima',
								caption: 'Si lo sabes. Oceánico, mediterráneo, urbano, litoral, montaña...',
								placeholder: 'Clima del jardín',
								type: 'string',
							},
							{
								inputId: '01-01-01-03',
								identifier: 'ORIENTATION',
								label: 'Orientación',
								caption: 'Si la sabes. Norte, Sur, Este, Oeste.',
								placeholder: '¿Cuál es la orientación del jardín?',
								type: 'string',
							},
							{
								inputId: '01-01-01-04',
								identifier: 'AREA',
								label: 'Superficie disponible',
								caption: 'En m2. Aproximadamente.',
								placeholder: 'Superficie disponible',
								type: 'number',
							},
							{
								inputId: '01-01-01-05',
								identifier: 'GROUND_TYPE',
								label: 'Tipo del terreno',
								caption: 'Si lo sabes. Árido, húmedo...',
								placeholder: 'Tipo del terreno',
								type: 'string',
							},
							{
								inputId: '01-01-01-06',
								identifier: 'HAS_MAINTENANCE',
								label: '¿El terreno disponible tiene mantenimiento?',
								caption: 'Si lo sabes',
								placeholder: '¿Tiene mantenimiento?',
								type: 'select',
								options: [
									{
										inputId: '01-01-01-06-01',
										identifier: 'YES',
										label: 'Sí',
									},
									{
										inputId: '01-01-01-06-02',
										identifier: 'NO',
										label: 'No',
									},
									{
										inputId: '01-01-01-06-03',
										identifier: 'MEDIUM',
										label: 'Más o menos...',
									},
								],
							},
							{
								inputId: '01-01-01-07',
								identifier: 'EXTRA',
								label: 'Comentarios extra',
								caption: '',
								placeholder:
									'Cualquier comentario es interesante para definir las características del diseño que te propondremos.',
								type: 'textarea',
							},
						],
					},
					{
						step2typeId: '01-01-02',
						identifier: 'NO',
						label: 'No',
						subLabel: '¿Podéis proponerme opciones?',
						question: 'Completa toda la información que puedas',
						inputs: [
							{
								inputId: '01-01-02-01',
								identifier: 'DESIGN_TYPE',
								label: 'Tipo principal',
								caption: 'Si quieres elegir uno',
								placeholder: 'Selecciona un tipo',
								type: 'select',
								options: [
									{
										selectId: '01-01-02-01-01',
										identifier: 'mediterraneo',
										label: 'Mediterráneo',
									},
									{
										selectId: '01-01-02-01-02',
										identifier: 'zen',
										label: 'Zen',
									},
									{
										selectId: '01-01-02-01-03',
										identifier: 'paisajista',
										label: 'Paisajista',
									},
									{
										selectId: '01-01-02-01-04',
										identifier: 'aromaticas',
										label: 'Aromáticas',
									},
									{
										selectId: '01-01-02-01-05',
										identifier: 'frances',
										label: 'Francés',
									},
								],
							},
							{
								inputId: '01-01-02-02',
								identifier: 'WEATHER',
								label: 'Clima',
								caption: 'Si lo sabes. Oceánico, mediterráneo, urbano, litoral, montaña...',
								placeholder: 'Clima del jardín',
								type: 'string',
							},
							{
								inputId: '01-01-02-03',
								identifier: 'ORIENTATION',
								label: 'Orientación',
								caption: 'Si la sabes. Norte, Sur, Este, Oeste.',
								placeholder: '¿Cuál es la orientación del jardín?',
								type: 'string',
							},
							{
								inputId: '01-01-02-04',
								identifier: 'AREA',
								label: 'Superficie disponible',
								caption: 'En m2. Aproximadamente.',
								placeholder: 'Superficie disponible',
								type: 'number',
							},
							{
								inputId: '01-01-02-05',
								identifier: 'GROUND_TYPE',
								label: 'Tipo del terreno',
								caption: 'Si lo sabes. Árido, húmedo...',
								placeholder: 'Tipo del terreno',
								type: 'string',
							},
							{
								inputId: '01-01-02-06',
								identifier: 'HAS_MAINTENANCE',
								label: '¿El terreno disponible tiene mantenimiento?',
								caption: 'Si lo sabes',
								placeholder: '¿Tiene mantenimiento?',
								type: 'select',
								options: [
									{
										inputId: '01-01-02-06-01',
										identifier: 'YES',
										label: 'Sí',
									},
									{
										inputId: '01-01-02-06-02',
										identifier: 'NO',
										label: 'No',
									},
									{
										inputId: '01-01-02-06-03',
										identifier: 'MEDIUM',
										label: 'Más o menos...',
									},
								],
							},
							{
								inputId: '01-01-02-07',
								identifier: 'EXTRA',
								label: 'Comentarios extra',
								caption: '',
								placeholder:
									'Cualquier comentario es interesante para definir las características del diseño que te propondremos.',
								type: 'textarea',
							},
						],
					},
				],
			},
			{
				step1typeId: '01-02',
				identifier: 'NO',
				label: 'No',
				subLabel: '¿Podéis proponerme opciones?',
				question: 'Completa toda la información que puedas',
				inputs: [
					{
						inputId: '01-02-01',
						identifier: 'WEATHER',
						label: 'Clima',
						caption: 'Si lo sabes. Oceánico, mediterráneo, urbano, litoral, montaña...',
						placeholder: 'Clima del jardín',
						type: 'string',
					},
					{
						inputId: '01-02-02',
						identifier: 'ORIENTATION',
						label: 'Orientación',
						caption: 'Si la sabes. Norte, Sur, Este, Oeste.',
						placeholder: '¿Cuál es la orientación del jardín?',
						type: 'string',
					},
					{
						inputId: '01-02-03',
						identifier: 'AREA',
						label: 'Superficie disponible',
						caption: 'En m2. Aproximadamente.',
						placeholder: 'Superficie disponible',
						type: 'number',
					},
					{
						inputId: '02-01-04',
						identifier: 'GROUND_TYPE',
						label: 'Tipo del terreno',
						caption: 'Si lo sabes. Árido, húmedo...',
						placeholder: 'Tipo del terreno',
						type: 'string',
					},
					{
						inputId: '01-02-05',
						identifier: 'HAS_MAINTENANCE',
						label: '¿El terreno disponible tiene mantenimiento?',
						caption: 'Si lo sabes',
						placeholder: '¿Tiene mantenimiento?',
						type: 'select',
						options: [
							{
								inputId: '01-02-05-01',
								identifier: 'YES',
								label: 'Sí',
							},
							{
								inputId: '01-02-05-02',
								identifier: 'NO',
								label: 'No',
							},
							{
								inputId: '01-02-05-03',
								identifier: 'MEDIUM',
								label: 'Más o menos...',
							},
						],
					},
					{
						inputId: '01-02-06',
						identifier: 'EXTRA',
						label: 'Comentarios extra',
						caption: '',
						placeholder: '¿Quieres añadir algún comentario a tu solicitud?',
						type: 'textarea',
					},
				],
			},
		],
	},
	{
		id: '02',
		identifier: 'ADD_TO_GARDEN',
		label: 'Añadir al jardín',
		subLabel: '',
		question: '¿Qué quieres añadir?',
		step1types: [
			{
				step1typeId: '02-01',
				identifier: 'PLANTS',
				label: 'Plantas',
				subLabel: 'Ornamentales, césped, setos, árboles, palmeras...',
				question: '¿Sabes qué quieres plantar?',
				step2types: [
					{
						step2typeId: '02-01-01',
						identifier: 'YES',
						label: 'Sí',
						subLabel: 'Sé lo que quiero',
						question: '¿Qué quieres plantar?',
						step3types: [
							{
								step3typeId: '02-01-01-01',
								identifier: 'ORNAMENTAL_PLANTS',
								label: 'Ornamentales',
								subLabel: '',
								question: 'Completa toda la información que puedas',
								inputs: [
									{
										inputId: '02-01-01-01-01',
										identifier: 'SPECIE',
										label: 'Especie',
										caption: 'Si la sabes y quieres una en concreto',
										placeholder: 'Especie de la planta',
										type: 'string',
									},
									{
										inputId: '02-01-01-01-02',
										identifier: 'AMOUNT',
										label: 'Cantidad',
										caption: 'De esta especie',
										placeholder: 'Número de plantas',
										type: 'number',
									},
									{
										inputId: '02-01-01-01-03',
										identifier: 'EXTRA',
										label: 'Comentarios extra',
										caption: '',
										placeholder:
											'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
										type: 'textarea',
									},
								],
							},
							{
								step3typeId: '02-01-01-02',
								identifier: 'GRASS',
								label: 'Césped',
								subLabel: '',
								question: 'Completa toda la información que puedas',
								inputs: [
									{
										inputId: '02-01-01-02-01',
										identifier: 'SPECIE',
										label: 'Tipo / Especie',
										caption: 'Si lo sabes y quieres uno en concreto',
										placeholder: 'Especie del cesped',
										type: 'string',
									},
									{
										inputId: '02-01-01-02-02',
										identifier: 'AREA',
										label: 'Superficie a cubrir',
										caption: 'En m2. Aproximadamente.',
										placeholder: 'Superficie deseada de cesped',
										type: 'number',
									},
									{
										inputId: '02-01-01-02-03',
										identifier: 'EXTRA',
										label: 'Comentarios extra',
										caption: '',
										placeholder:
											'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
										type: 'textarea',
									},
								],
							},
							{
								step3typeId: '02-01-01-03',
								identifier: 'HEDGES',
								label: 'Setos',
								subLabel: '',
								question: 'Completa toda la información que puedas',
								inputs: [
									{
										inputId: '02-01-01-03-01',
										identifier: 'TYPE',
										label: 'Tipo',
										caption: 'Si lo sabes y quieres uno en concreto',
										placeholder: 'Lineal / De valla',
										type: 'string',
									},
									{
										inputId: '02-01-01-03-02',
										identifier: 'SPECIE',
										label: 'Especie',
										caption: 'Si la sabes y quieres una en concreto',
										placeholder: 'Especie del seto',
										type: 'string',
									},
									{
										inputId: '02-01-01-03-03',
										identifier: 'DIMENSIONS',
										label: 'Dimensiones',
										caption: 'Ancho x Alto x Largo en metros aprox.',
										placeholder: 'Dimensiones del seto',
										type: 'string',
									},
									{
										inputId: '02-01-01-03-04',
										identifier: 'EXTRA',
										label: 'Comentarios extra',
										caption: '',
										placeholder:
											'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
										type: 'textarea',
									},
								],
							},
							{
								step3typeId: '02-01-01-04',
								identifier: 'ARBUSTOS',
								label: 'Arbustos',
								subLabel: '',
								question: 'Completa toda la información que puedas',
								inputs: [
									{
										inputId: '02-01-01-04-01',
										identifier: 'SPECIE',
										label: 'Especie',
										caption: 'Si la sabes y quieres una en concreto',
										placeholder: 'Especie del arbusto',
										type: 'string',
									},
									{
										inputId: '02-01-01-04-02',
										identifier: 'AMOUNT',
										label: 'Cantidad',
										caption: 'De esta especie',
										placeholder: 'Número de arbustos',
										type: 'number',
									},
									{
										inputId: '02-01-01-04-03',
										identifier: 'EXTRA',
										label: 'Comentarios extra',
										caption: '',
										placeholder:
											'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
										type: 'textarea',
									},
								],
							},
							{
								step3typeId: '02-01-01-05',
								identifier: 'TREES',
								label: 'Árboles',
								subLabel: '',
								question: 'Completa toda la información que puedas',
								inputs: [
									{
										inputId: '02-01-01-05-01',
										identifier: 'SPECIE',
										label: 'Especie',
										caption: 'Si la sabes y quieres una en concreto',
										placeholder: 'Especie del árbol',
										type: 'string',
									},
									{
										inputId: '02-01-01-05-02',
										identifier: 'AMOUNT',
										label: 'Cantidad',
										caption: 'De esta especie',
										placeholder: 'Número de árboles',
										type: 'number',
									},
									{
										inputId: '02-01-01-05-03',
										identifier: 'EXTRA',
										label: 'Comentarios extra',
										caption: '',
										placeholder:
											'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
										type: 'textarea',
									},
								],
							},
							{
								step3typeId: '02-01-01-06',
								identifier: 'PALMS',
								label: 'Palmeras',
								subLabel: '',
								question: 'Completa toda la información que puedas',
								inputs: [
									{
										inputId: '02-01-01-06-01',
										identifier: 'SPECIE',
										label: 'Especie',
										caption: 'Si la sabes y quieres una en concreto',
										placeholder: 'Especie de la palmera',
										type: 'string',
									},
									{
										inputId: '02-01-01-06-02',
										identifier: 'AMOUNT',
										label: 'Cantidad',
										caption: 'De este tipo',
										placeholder: 'Número de palmeras',
										type: 'number',
									},
									{
										inputId: '02-01-01-06-03',
										identifier: 'EXTRA',
										label: 'Comentarios extra',
										caption: '',
										placeholder:
											'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
										type: 'textarea',
									},
								],
							},
						],
					},
					{
						step2typeId: '02-01-02',
						identifier: 'NO',
						label: 'No',
						subLabel: '¿Podéis proponerme?',
						question: 'Completa toda la información que puedas',
						inputs: [
							{
								inputId: '02-01-02-01',
								identifier: 'WEATHER',
								label: 'Clima',
								caption: 'Si lo sabes. Oceánico, mediterráneo, urbano, litoral, montaña...',
								placeholder: 'Clima del jardín',
								type: 'string',
							},
							{
								inputId: '02-01-02-02',
								identifier: 'ORIENTATION',
								label: 'Orientación',
								caption: 'Si la sabes. Norte, Sur, Este, Oeste.',
								placeholder: '¿Cuál es la orientación del jardín?',
								type: 'string',
							},
							{
								inputId: '02-01-02-03',
								identifier: 'AREA',
								label: 'Superficie disponible',
								caption: 'En m2. Aproximadamente.',
								placeholder: 'Superficie disponible',
								type: 'number',
							},
							{
								inputId: '02-01-02-04',
								identifier: 'GROUND_TYPE',
								label: 'Tipo del terreno',
								caption: 'Si lo sabes. Árido, húmedo...',
								placeholder: 'Tipo del terreno',
								type: 'string',
							},
							{
								inputId: '02-01-02-05',
								identifier: 'HAS_MAINTENANCE',
								label: '¿El terreno disponible tiene mantenimiento?',
								caption: 'Si lo sabes',
								placeholder: '¿Tiene mantenimiento?',
								type: 'select',
								options: [
									{
										inputId: '02-01-02-05-01',
										identifier: 'YES',
										label: 'Sí',
									},
									{
										inputId: '02-01-02-05-02',
										identifier: 'NO',
										label: 'No',
									},
									{
										inputId: '02-01-02-05-03',
										identifier: 'MEDIUM',
										label: 'Más o menos...',
									},
								],
							},
							{
								inputId: '02-01-02-06',
								identifier: 'OTHER_PLANTS',
								label: '¿Hay otras plantas alrededor? ¿Cuáles?',
								caption: 'Si lo sabes',
								placeholder: '¿Otras plantas?',
								type: 'string',
							},
							{
								inputId: '02-01-02-07',
								identifier: 'EXTRA',
								label: 'Comentarios extra',
								caption: '',
								placeholder:
									'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
								type: 'textarea',
							},
						],
					},
				],
			},
			{
				step1typeId: '02-02',
				identifier: 'IRRIGATION',
				label: 'Sistema de riego',
				subLabel: 'Aspersión, goteo...',
				question: '¿Sabes qué sistema quieres utilizar?',
				step2types: [
					{
						step2typeId: '02-02-01',
						identifier: 'YES',
						label: 'Sí',
						subLabel: 'Sé lo que quiero',
						question: '¿Qué sistema quieres?',
						step3types: [
							{
								step3typeId: '02-02-01-01',
								identifier: 'ASPERSION',
								label: 'Aspersión',
								subLabel: '',
								question: 'Completa toda la información que puedas',
								inputs: [
									{
										inputId: '02-02-01-01-01',
										identifier: 'AREA',
										label: 'Superficie a regar',
										caption: 'En m2. Aproximadamente.',
										placeholder: 'Superficie a regar',
										type: 'number',
									},
									{
										inputId: '02-02-01-01-02',
										identifier: 'GROUND_TYPE',
										label: 'Tipo del terreno',
										caption: 'Si lo sabes. Árido, húmedo...',
										placeholder: 'Tipo del terreno',
										type: 'string',
									},
									{
										inputId: '02-02-01-01-03',
										identifier: 'EXTRA',
										label: 'Comentarios extra',
										caption: '',
										placeholder:
											'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
										type: 'textarea',
									},
								],
							},
							{
								step3typeId: '02-02-01-02',
								identifier: 'GOTEO',
								label: 'Goteo',
								subLabel: '',
								question: 'Completa toda la información que puedas',
								inputs: [
									{
										inputId: '02-02-01-02-01',
										identifier: 'AREA',
										label: 'Superficie a regar',
										caption: 'En m2. Aproximadamente.',
										placeholder: 'Superficie a regar',
										type: 'number',
									},
									{
										inputId: '02-02-01-02-02',
										identifier: 'GROUND_TYPE',
										label: 'Tipo del terreno',
										caption: 'Si lo sabes. Árido, húmedo...',
										placeholder: 'Tipo del terreno',
										type: 'string',
									},
									{
										inputId: '02-02-01-02-03',
										identifier: 'EXTRA',
										label: 'Comentarios extra',
										caption: '',
										placeholder:
											'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
										type: 'textarea',
									},
								],
							},
							{
								step3typeId: '02-02-01-03',
								identifier: 'OTHER',
								label: 'Otros',
								subLabel: '',
								question: 'Completa toda la información que puedas',
								inputs: [
									{
										inputId: '02-02-01-03-01',
										identifier: 'AREA',
										label: 'Superficie a regar',
										caption: 'En m2. Aproximadamente.',
										placeholder: 'Superficie a regar',
										type: 'number',
									},
									{
										inputId: '02-02-01-03-02',
										identifier: 'GROUND_TYPE',
										label: 'Tipo del terreno',
										caption: 'Si lo sabes. Árido, húmedo...',
										placeholder: 'Tipo del terreno',
										type: 'string',
									},
									{
										inputId: '02-02-01-03-03',
										identifier: 'EXTRA',
										label: 'Comentarios extra',
										caption: '',
										placeholder:
											'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
										type: 'textarea',
									},
								],
							},
						],
					},
					{
						step2typeId: '02-02-02',
						identifier: 'NO',
						label: 'No',
						subLabel: '¿Podéis proponerme?',
						question: 'Completa toda la información que puedas',
						inputs: [
							{
								inputId: '02-02-02-01',
								identifier: 'WEATHER',
								label: 'Clima',
								caption: 'Si lo sabes. Oceánico, mediterráneo, urbano, litoral, montaña...',
								placeholder: 'Clima del jardín',
								type: 'string',
							},
							{
								inputId: '02-02-02-02',
								identifier: 'AREA',
								label: 'Superficie a regar',
								caption: 'En m2. Aproximadamente.',
								placeholder: 'Superficie a regar',
								type: 'number',
							},
							{
								inputId: '02-02-02-03',
								identifier: 'GROUND_TYPE',
								label: 'Tipo del terreno',
								caption: 'Si lo sabes. Árido, húmedo...',
								placeholder: 'Tipo del terreno',
								type: 'string',
							},
							{
								inputId: '02-02-02-04',
								identifier: 'EXTRA',
								label: 'Comentarios extra',
								caption: '',
								placeholder:
									'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
								type: 'textarea',
							},
						],
					},
				],
			},
			{
				step1typeId: '02-03',
				identifier: 'OTHER',
				label: 'Otros',
				subLabel: 'Iluminación, mobiliario, piscinas...',
				question: '¿Qué quieres añadir?',
				step2types: [
					{
						step2typeId: '02-03-01',
						identifier: 'LIGHTING',
						label: 'Iluminación',
						subLabel: '',
						question: '¿Qué tipo de luz quieres?',
						inputs: [
							{
								inputId: '02-03-01-01',
								identifier: 'EXTRA',
								label: '',
								caption: '',
								placeholder: 'Explicanos qué tipo de luz necesitas',
								type: 'textarea',
							},
							{
								inputId: '02-03-01-02',
								identifier: 'AMOUNT',
								label: 'Cantidad',
								caption: 'De este tipo de luces',
								placeholder: 'Número de luces',
								type: 'number',
							},
						],
					},
					{
						step2typeId: '02-03-02',
						identifier: 'FURNITURE',
						label: 'Mobiliario',
						subLabel: 'Mesas, sillas, hamacas, parasoles, pergolas...',
						question: '¿Qué necesitas?',
						step3types: [
							{
								step3typeId: '02-03-02-01',
								identifier: 'SETS',
								label: 'Conjuntos',
								subLabel: 'Sillas, mesas, sofás...',
								question: '¿Qué conjunto quieres?',
								inputs: [
									{
										inputId: '02-03-02-01-01',
										identifier: 'EXTRA',
										label: '',
										caption: '',
										placeholder: 'Explicanos qué tipo de conjunto necesitas',
										type: 'textarea',
									},
								],
							},
							{
								step3typeId: '02-03-02-02',
								identifier: 'TABLES',
								label: 'Mesas',
								subLabel: '',
								question: '¿Qué tipo de mesa necesitas?',
								inputs: [
									{
										inputId: '02-03-02-02-01',
										identifier: 'EXTRA',
										label: '',
										caption: '',
										placeholder: 'Explicanos qué tipo de mesa buscas',
										type: 'textarea',
									},
									{
										inputId: '02-03-02-02-02',
										identifier: 'AMOUNT',
										label: 'Cantidad',
										caption: '',
										placeholder: 'Número de mesas',
										type: 'number',
									},
								],
							},
							{
								step3typeId: '02-03-02-03',
								identifier: 'CHAIRS',
								label: 'Sillas',
								subLabel: '',
								question: '¿Qué tipo de silla necesitas?',
								inputs: [
									{
										inputId: '02-03-02-03-01',
										identifier: 'EXTRA',
										label: '',
										caption: '',
										placeholder: 'Explicanos qué tipo de silla buscas',
										type: 'textarea',
									},
									{
										inputId: '02-03-02-03-02',
										identifier: 'AMOUNT',
										label: 'Cantidad',
										caption: '',
										placeholder: 'Número de sillas',
										type: 'number',
									},
								],
							},
							{
								step3typeId: '02-03-02-04',
								identifier: 'HAMMOCKS',
								label: 'Hamacas',
								subLabel: '',
								question: '¿Qué tipo de hamaca necesitas?',
								inputs: [
									{
										inputId: '02-03-02-04-01',
										identifier: 'EXTRA',
										label: '',
										caption: '',
										placeholder: 'Explicanos qué tipo de hamaca buscas',
										type: 'textarea',
									},
									{
										inputId: '02-03-02-04-02',
										identifier: 'AMOUNT',
										label: 'Cantidad',
										caption: '',
										placeholder: 'Número de hamacas',
										type: 'number',
									},
								],
							},
							{
								step3typeId: '02-03-02-05',
								identifier: 'BALINESE_BEDS',
								label: 'Camas balinesas',
								subLabel: '',
								question: '¿Qué tipo de cama balinesa necesitas?',
								inputs: [
									{
										inputId: '02-03-02-05-01',
										identifier: 'EXTRA',
										label: '',
										caption: '',
										placeholder: 'Explicanos qué tipo de cama balinesa buscas',
										type: 'textarea',
									},
									{
										inputId: '02-03-02-05-02',
										identifier: 'AMOUNT',
										label: 'Cantidad',
										caption: '',
										placeholder: 'Número de camas balinesas',
										type: 'number',
									},
								],
							},
							{
								step3typeId: '02-03-02-06',
								identifier: 'PERGOLAS',
								label: 'Pérgolas',
								subLabel: '',
								question: '¿Qué tipo de pérgola necesitas?',
								inputs: [
									{
										inputId: '02-03-02-06-01',
										identifier: 'EXTRA',
										label: '',
										caption: '',
										placeholder: 'Explicanos qué tipo de pérgola buscas',
										type: 'textarea',
									},
									{
										inputId: '02-03-02-06-02',
										identifier: 'AMOUNT',
										label: 'Cantidad',
										caption: '',
										placeholder: 'Número de pérgolas',
										type: 'number',
									},
								],
							},
							{
								step3typeId: '02-03-02-07',
								identifier: 'PARASOLS',
								label: 'Parasoles',
								subLabel: '',
								question: '¿Qué tipo de parasol necesitas?',
								inputs: [
									{
										inputId: '02-03-02-07-01',
										identifier: 'EXTRA',
										label: '',
										caption: '',
										placeholder: 'Explicanos qué tipo de parasol buscas',
										type: 'textarea',
									},
									{
										inputId: '02-03-02-07-02',
										identifier: 'AMOUNT',
										label: 'Cantidad',
										caption: '',
										placeholder: 'Número de parasoles',
										type: 'number',
									},
								],
							},
							{
								step3typeId: '02-03-02-08',
								identifier: 'OTHER',
								label: 'Otros',
								subLabel: '',
								question: '¿Qué necesitas?',
								inputs: [
									{
										inputId: '02-03-02-08-01',
										identifier: 'EXTRA',
										label: '',
										caption: '',
										placeholder: 'Explicanos qué necesitas con el máximo detalle que puedas',
										type: 'textarea',
									},
								],
							},
						],
					},
					{
						step2typeId: '02-03-03',
						identifier: 'SWIMMING_POOLS',
						label: 'Piscinas',
						subLabel: '',
						question: '¿Qué tipo de piscina necesitas?',
						step3types: [
							{
								step3typeId: '02-03-03-01',
								identifier: 'INFLATABLES',
								label: 'Hinchables y tubulares',
								subLabel: '',
								question: 'Detalles de la piscina',
								inputs: [
									{
										inputId: '02-03-03-01-01',
										identifier: 'EXTRA',
										label: '',
										caption: '',
										placeholder:
											'Explicanos qué tipo de piscina necesitas o cualquier detalle extra que se te ocurra',
										type: 'textarea',
									},
									{
										inputId: '02-03-03-01-02',
										identifier: 'DIMENSIONS',
										label: 'Dimensiones',
										caption: 'Ancho x Alto x Largo en metros aprox.',
										placeholder: 'Dimensiones de la piscina',
										type: 'string',
									},
								],
							},
							{
								step3typeId: '02-03-03-02',
								identifier: 'REMOVABLE',
								label: 'Desmontables de acero y madera',
								subLabel: '',
								question: 'Detalles de la piscina',
								inputs: [
									{
										inputId: '02-03-03-02-01',
										identifier: 'EXTRA',
										label: '',
										caption: '',
										placeholder:
											'Explicanos qué tipo de piscina necesitas o cualquier detalle extra que se te ocurra',
										type: 'textarea',
									},
									{
										inputId: '02-03-03-02-02',
										identifier: 'DIMENSIONS',
										label: 'Dimensiones',
										caption: 'Ancho x Alto x Largo en metros aprox.',
										placeholder: 'Dimensiones de la piscina',
										type: 'string',
									},
								],
							},
							{
								step3typeId: '02-03-03-03',
								identifier: 'BUILDED',
								label: 'De construcción',
								subLabel: '',
								question: 'Detalles de la piscina',
								inputs: [
									{
										inputId: '02-03-03-03-01',
										identifier: 'EXTRA',
										label: '',
										caption: '',
										placeholder:
											'Explicanos qué tipo de piscina necesitas o cualquier detalle extra que se te ocurra',
										type: 'textarea',
									},
									{
										inputId: '02-03-03-03-02',
										identifier: 'DIMENSIONS',
										label: 'Dimensiones',
										caption: 'Ancho x Alto x Largo en metros aprox.',
										placeholder: 'Dimensiones de la piscina',
										type: 'string',
									},
								],
							},
						],
					},
					{
						step2typeId: '02-03-04',
						identifier: 'MACHINERY_AND_TOOLS',
						label: 'Maquinaria y Herramientas',
						subLabel: '',
						question: '¿Qué necesitas?',
						step3types: [
							{
								step3typeId: '02-03-03-01',
								identifier: 'MOWER',
								label: 'Cortacésped',
								subLabel: '',
								question: 'Detalles del cortacésped',
								inputs: [
									{
										inputId: '02-03-03-01-01',
										identifier: 'EXTRA',
										label: '',
										caption: '',
										placeholder:
											'Explicanos qué tipo de cortacésped necesitas o cualquier detalle extra que se te ocurra',
										type: 'textarea',
									},
								],
							},
							{
								step3typeId: '02-03-03-02',
								identifier: 'BRUSHCUTTER',
								label: 'Desbrozadora',
								subLabel: '',
								question: 'Detalles de la desbrozadora',
								inputs: [
									{
										inputId: '02-03-03-02-01',
										identifier: 'EXTRA',
										label: '',
										caption: '',
										placeholder:
											'Explicanos qué tipo de desbrozadora necesitas o cualquier detalle extra que se te ocurra',
										type: 'textarea',
									},
								],
							},
							{
								step3typeId: '02-03-03-03',
								identifier: 'CHAINSAW',
								label: 'Motosierra',
								subLabel: '',
								question: 'Detalles de la motosierra',
								inputs: [
									{
										inputId: '02-03-03-03-01',
										identifier: 'EXTRA',
										label: '',
										caption: '',
										placeholder:
											'Explicanos qué tipo de motosierra necesitas o cualquier detalle extra que se te ocurra',
										type: 'textarea',
									},
								],
							},
							{
								step3typeId: '02-03-03-04',
								identifier: 'HEDGE_TRIMMER',
								label: 'Cortasetos',
								subLabel: '',
								question: 'Detalles del cortasetos',
								inputs: [
									{
										inputId: '02-03-03-04-01',
										identifier: 'EXTRA',
										label: '',
										caption: '',
										placeholder:
											'Explicanos qué tipo de cortasetos necesitas o cualquier detalle extra que se te ocurra',
										type: 'textarea',
									},
								],
							},
							{
								step3typeId: '02-03-03-05',
								identifier: 'OTHER',
								label: 'Otros',
								subLabel: 'Vareadores, cortatroncos, hidrolimpiadoras...',
								question: '¿Qué herramienta necesitas?',
								inputs: [
									{
										inputId: '02-03-03-05-01',
										identifier: 'EXTRA',
										label: '',
										caption: '',
										placeholder:
											'Explicanos qué tipo de herramienta necesitas o cualquier detalle extra que se te ocurra',
										type: 'textarea',
									},
								],
							},
						],
					},
				],
			},
		],
	},
	{
		id: '03',
		identifier: 'MANTAIN_GARDEN',
		label: 'Mantenimiento del jardín',
		subLabel: '',
		question: '¿Qué necesitas hacer?',
		step1types: [
			{
				step1typeId: '03-01',
				identifier: 'PRUNING',
				label: 'Podar',
				subLabel: 'Plantas, césped, setos, árboles, palmeras...',
				question: '¿Qué necesitas podar?',
				step2types: [
					{
						step2typeId: '03-01-01',
						identifier: 'ORNAMENTAL_PLANTS',
						label: 'Ornamentales',
						subLabel: '',
						question: 'Completa toda la información que puedas',
						inputs: [
							{
								inputId: '03-01-01-01',
								identifier: 'SPECIE',
								label: 'Especie',
								caption: 'Si la sabes',
								placeholder: 'Especie de la planta',
								type: 'string',
							},
							{
								inputId: '03-01-01-02',
								identifier: 'AMOUNT',
								label: 'Cantidad',
								caption: 'De esta especie',
								placeholder: 'Número de plantas',
								type: 'number',
							},
							{
								inputId: '03-01-01-03',
								identifier: 'EXTRA',
								label: 'Comentarios extra',
								caption: '',
								placeholder:
									'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
								type: 'textarea',
							},
						],
					},
					{
						step2typeId: '03-01-02',
						identifier: 'GRASS',
						label: 'Césped',
						subLabel: 'Cortar',
						question: 'Completa toda la información que puedas',
						inputs: [
							{
								inputId: '03-01-02-01',
								identifier: 'SPECIE',
								label: 'Tipo / Especie',
								caption: 'Si lo sabes',
								placeholder: 'Especie del cesped',
								type: 'string',
							},
							{
								inputId: '03-01-02-02',
								identifier: 'AREA',
								label: 'Superficie a recortar',
								caption: 'En m2. Aproximadamente.',
								placeholder: 'Superficie a recortar',
								type: 'number',
							},
							{
								inputId: '03-01-02-03',
								identifier: 'EXTRA',
								label: 'Comentarios extra',
								caption: '',
								placeholder:
									'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
								type: 'textarea',
							},
						],
					},
					{
						step2typeId: '03-01-03',
						identifier: 'HEDGES',
						label: 'Setos',
						subLabel: '',
						question: 'Completa toda la información que puedas',
						inputs: [
							{
								inputId: '03-01-03-01',
								identifier: 'TYPE',
								label: 'Tipo',
								caption: 'Si lo sabes',
								placeholder: 'Lineal / De valla',
								type: 'string',
							},
							{
								inputId: '03-01-03-02',
								identifier: 'SPECIE',
								label: 'Especie',
								caption: 'Si la sabes',
								placeholder: 'Especie del seto',
								type: 'string',
							},
							{
								inputId: '03-01-03-03',
								identifier: 'DIMENSIONS',
								label: 'Dimensiones',
								caption: 'Ancho x Alto x Largo en metros aprox.',
								placeholder: 'Dimensiones del seto',
								type: 'string',
							},
							{
								inputId: '03-01-03-04',
								identifier: 'EXTRA',
								label: 'Comentarios extra',
								caption: '',
								placeholder:
									'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
								type: 'textarea',
							},
						],
					},
					{
						step2typeId: '03-01-04',
						identifier: 'ARBUSTOS',
						label: 'Arbustos',
						subLabel: '',
						question: 'Completa toda la información que puedas',
						inputs: [
							{
								inputId: '03-01-04-01',
								identifier: 'SPECIE',
								label: 'Especie',
								caption: 'Si la sabes',
								placeholder: 'Especie del arbusto',
								type: 'string',
							},
							{
								inputId: '03-01-04-02',
								identifier: 'AMOUNT',
								label: 'Cantidad',
								caption: 'De esta especie',
								placeholder: 'Número de arbustos',
								type: 'number',
							},
							{
								inputId: '03-01-04-03',
								identifier: 'EXTRA',
								label: 'Comentarios extra',
								caption: '',
								placeholder:
									'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
								type: 'textarea',
							},
						],
					},
					{
						step2typeId: '03-01-05',
						identifier: 'TREES',
						label: 'Árboles',
						subLabel: '',
						question: 'Completa toda la información que puedas',
						inputs: [
							{
								inputId: '03-01-05-01',
								identifier: 'SPECIE',
								label: 'Especie',
								caption: 'Si la sabes',
								placeholder: 'Especie del árbol',
								type: 'string',
							},
							{
								inputId: '03-01-06-02',
								identifier: 'HEIGTH',
								label: 'Altura',
								caption: 'Altura media en metros',
								placeholder: 'Altura media de los arboles',
								type: 'string',
							},
							{
								inputId: '03-01-05-03',
								identifier: 'AMOUNT',
								label: 'Cantidad',
								caption: 'De esta especie',
								placeholder: 'Número de árboles',
								type: 'number',
							},
							{
								inputId: '03-01-05-04',
								identifier: 'EXTRA',
								label: 'Comentarios extra',
								caption: '',
								placeholder:
									'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
								type: 'textarea',
							},
						],
					},
					{
						step2typeId: '03-01-06',
						identifier: 'PALMS',
						label: 'Palmeras',
						subLabel: '',
						question: 'Completa toda la información que puedas',
						inputs: [
							{
								inputId: '03-01-06-01',
								identifier: 'SPECIE',
								label: 'Especie',
								caption: 'Si la sabes',
								placeholder: 'Especie de la palmera',
								type: 'string',
							},
							{
								inputId: '03-01-06-02',
								identifier: 'HEIGTH',
								label: 'Altura',
								caption: 'Altura media en metros',
								placeholder: 'Altura media de las palmeras',
								type: 'string',
							},
							{
								inputId: '03-01-06-03',
								identifier: 'AMOUNT',
								label: 'Cantidad',
								caption: 'De este tipo',
								placeholder: 'Número de palmeras',
								type: 'number',
							},
							{
								inputId: '03-01-06-04',
								identifier: 'EXTRA',
								label: 'Comentarios extra',
								caption: '',
								placeholder:
									'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
								type: 'textarea',
							},
						],
					},
				],
			},
			{
				step1typeId: '03-02',
				identifier: 'REPLANT',
				label: 'Replantar',
				subLabel: 'Plantas, césped, setos, árboles, palmeras...',
				question: '¿Qué necesitas replantar?',
				step2types: [
					{
						step2typeId: '03-02-01',
						identifier: 'ORNAMENTAL_PLANTS',
						label: 'Ornamentales',
						subLabel: '',
						question: 'Completa toda la información que puedas',
						inputs: [
							{
								inputId: '03-02-01-01',
								identifier: 'SPECIE',
								label: 'Especie',
								caption: 'Si la sabes',
								placeholder: 'Especie de la planta',
								type: 'string',
							},
							{
								inputId: '03-02-01-02',
								identifier: 'AMOUNT',
								label: 'Cantidad',
								caption: 'De esta especie',
								placeholder: 'Número de plantas',
								type: 'number',
							},
							{
								inputId: '03-02-01-03',
								identifier: 'EXTRA',
								label: 'Comentarios extra',
								caption: '',
								placeholder:
									'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
								type: 'textarea',
							},
						],
					},
					{
						step2typeId: '03-02-02',
						identifier: 'GRASS',
						label: 'Césped',
						subLabel: 'Resembrar',
						question: 'Completa toda la información que puedas',
						inputs: [
							{
								inputId: '03-02-02-01',
								identifier: 'SPECIE',
								label: 'Tipo / Especie',
								caption: 'Si lo sabes',
								placeholder: 'Especie del cesped',
								type: 'string',
							},
							{
								inputId: '03-02-02-02',
								identifier: 'AREA',
								label: 'Superficie a replantar',
								caption: 'En m2. Aproximadamente.',
								placeholder: 'Superficie a replantar',
								type: 'number',
							},
							{
								inputId: '03-02-02-03',
								identifier: 'EXTRA',
								label: 'Comentarios extra',
								caption: '',
								placeholder:
									'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
								type: 'textarea',
							},
						],
					},
					{
						step2typeId: '03-02-03',
						identifier: 'HEDGES',
						label: 'Setos',
						subLabel: '',
						question: 'Completa toda la información que puedas',
						inputs: [
							{
								inputId: '03-02-03-01',
								identifier: 'TYPE',
								label: 'Tipo',
								caption: 'Si lo sabes',
								placeholder: 'Lineal / De valla',
								type: 'string',
							},
							{
								inputId: '03-02-03-02',
								identifier: 'SPECIE',
								label: 'Especie',
								caption: 'Si la sabes',
								placeholder: 'Especie del seto',
								type: 'string',
							},
							{
								inputId: '03-02-03-03',
								identifier: 'DIMENSIONS',
								label: 'Dimensiones',
								caption: 'Ancho x Alto x Largo en metros aprox.',
								placeholder: 'Dimensiones del seto',
								type: 'string',
							},
							{
								inputId: '03-02-03-04',
								identifier: 'EXTRA',
								label: 'Comentarios extra',
								caption: '',
								placeholder:
									'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
								type: 'textarea',
							},
						],
					},
					{
						step2typeId: '03-02-04',
						identifier: 'ARBUSTOS',
						label: 'Arbustos',
						subLabel: '',
						question: 'Completa toda la información que puedas',
						inputs: [
							{
								inputId: '03-02-04-01',
								identifier: 'SPECIE',
								label: 'Especie',
								caption: 'Si la sabes',
								placeholder: 'Especie del arbusto',
								type: 'string',
							},
							{
								inputId: '03-02-04-02',
								identifier: 'AMOUNT',
								label: 'Cantidad',
								caption: 'De esta especie',
								placeholder: 'Número de arbustos',
								type: 'number',
							},
							{
								inputId: '03-02-04-03',
								identifier: 'EXTRA',
								label: 'Comentarios extra',
								caption: '',
								placeholder:
									'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
								type: 'textarea',
							},
						],
					},
					{
						step2typeId: '03-02-05',
						identifier: 'TREES',
						label: 'Árboles',
						subLabel: '',
						question: 'Completa toda la información que puedas',
						inputs: [
							{
								inputId: '03-02-05-01',
								identifier: 'SPECIE',
								label: 'Especie',
								caption: 'Si la sabes',
								placeholder: 'Especie del árbol',
								type: 'string',
							},
							{
								inputId: '03-02-06-02',
								identifier: 'HEIGTH',
								label: 'Altura',
								caption: 'Altura media en metros',
								placeholder: 'Altura media de los arboles',
								type: 'string',
							},
							{
								inputId: '03-02-05-03',
								identifier: 'AMOUNT',
								label: 'Cantidad',
								caption: 'De esta especie',
								placeholder: 'Número de árboles',
								type: 'number',
							},
							{
								inputId: '03-02-05-04',
								identifier: 'EXTRA',
								label: 'Comentarios extra',
								caption: '',
								placeholder:
									'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
								type: 'textarea',
							},
						],
					},
					{
						step2typeId: '03-02-06',
						identifier: 'PALMS',
						label: 'Palmeras',
						subLabel: '',
						question: 'Completa toda la información que puedas',
						inputs: [
							{
								inputId: '03-02-06-01',
								identifier: 'SPECIE',
								label: 'Especie',
								caption: 'Si la sabes',
								placeholder: 'Especie de la palmera',
								type: 'string',
							},
							{
								inputId: '03-02-06-02',
								identifier: 'HEIGTH',
								label: 'Altura',
								caption: 'Altura media en metros',
								placeholder: 'Altura media de las palmeras',
								type: 'string',
							},
							{
								inputId: '03-02-06-03',
								identifier: 'AMOUNT',
								label: 'Cantidad',
								caption: 'De este tipo',
								placeholder: 'Número de palmeras',
								type: 'number',
							},
							{
								inputId: '03-02-06-04',
								identifier: 'EXTRA',
								label: 'Comentarios extra',
								caption: '',
								placeholder:
									'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
								type: 'textarea',
							},
						],
					},
				],
			},
			{
				step1typeId: '03-03',
				identifier: 'IRRIGATE',
				label: 'Regar',
				subLabel: 'Plantas, césped, setos, árboles, palmeras...',
				question: '¿Qué necesitas regar?',
				step2types: [
					{
						step2typeId: '03-03-01',
						identifier: 'ORNAMENTAL_PLANTS',
						label: 'Ornamentales',
						subLabel: '',
						question: 'Completa toda la información que puedas',
						inputs: [
							{
								inputId: '03-03-01-01',
								identifier: 'SPECIE',
								label: 'Especie',
								caption: 'Si la sabes',
								placeholder: 'Especie de la planta',
								type: 'string',
							},
							{
								inputId: '03-03-01-02',
								identifier: 'AMOUNT',
								label: 'Cantidad',
								caption: 'De esta especie',
								placeholder: 'Número de plantas',
								type: 'number',
							},
							{
								inputId: '03-03-01-03',
								identifier: 'EXTRA',
								label: 'Comentarios extra',
								caption: '',
								placeholder:
									'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
								type: 'textarea',
							},
						],
					},
					{
						step2typeId: '03-03-02',
						identifier: 'GRASS',
						label: 'Césped',
						subLabel: '',
						question: 'Completa toda la información que puedas',
						inputs: [
							{
								inputId: '03-03-02-01',
								identifier: 'SPECIE',
								label: 'Tipo / Especie',
								caption: 'Si lo sabes',
								placeholder: 'Especie del cesped',
								type: 'string',
							},
							{
								inputId: '03-03-02-02',
								identifier: 'AREA',
								label: 'Superficie a regar',
								caption: 'En m2. Aproximadamente.',
								placeholder: 'Superficie a regar',
								type: 'number',
							},
							{
								inputId: '03-03-02-03',
								identifier: 'EXTRA',
								label: 'Comentarios extra',
								caption: '',
								placeholder:
									'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
								type: 'textarea',
							},
						],
					},
					{
						step2typeId: '03-03-03',
						identifier: 'HEDGES',
						label: 'Setos',
						subLabel: '',
						question: 'Completa toda la información que puedas',
						inputs: [
							{
								inputId: '03-03-03-01',
								identifier: 'TYPE',
								label: 'Tipo',
								caption: 'Si lo sabes',
								placeholder: 'Lineal / De valla',
								type: 'string',
							},
							{
								inputId: '03-03-03-02',
								identifier: 'SPECIE',
								label: 'Especie',
								caption: 'Si la sabes',
								placeholder: 'Especie del seto',
								type: 'string',
							},
							{
								inputId: '03-03-03-03',
								identifier: 'DIMENSIONS',
								label: 'Dimensiones',
								caption: 'Ancho x Alto x Largo en metros aprox.',
								placeholder: 'Dimensiones del seto',
								type: 'string',
							},
							{
								inputId: '03-03-03-04',
								identifier: 'EXTRA',
								label: 'Comentarios extra',
								caption: '',
								placeholder:
									'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
								type: 'textarea',
							},
						],
					},
					{
						step2typeId: '03-03-04',
						identifier: 'ARBUSTOS',
						label: 'Arbustos',
						subLabel: '',
						question: 'Completa toda la información que puedas',
						inputs: [
							{
								inputId: '03-03-04-01',
								identifier: 'SPECIE',
								label: 'Especie',
								caption: 'Si la sabes',
								placeholder: 'Especie del arbusto',
								type: 'string',
							},
							{
								inputId: '03-03-04-02',
								identifier: 'AMOUNT',
								label: 'Cantidad',
								caption: 'De esta especie',
								placeholder: 'Número de arbustos',
								type: 'number',
							},
							{
								inputId: '03-03-04-03',
								identifier: 'EXTRA',
								label: 'Comentarios extra',
								caption: '',
								placeholder:
									'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
								type: 'textarea',
							},
						],
					},
					{
						step2typeId: '03-03-05',
						identifier: 'TREES',
						label: 'Árboles',
						subLabel: '',
						question: 'Completa toda la información que puedas',
						inputs: [
							{
								inputId: '03-03-05-01',
								identifier: 'SPECIE',
								label: 'Especie',
								caption: 'Si la sabes',
								placeholder: 'Especie del árbol',
								type: 'string',
							},
							{
								inputId: '03-03-06-02',
								identifier: 'HEIGTH',
								label: 'Altura',
								caption: 'Altura media en metros',
								placeholder: 'Altura media de los arboles',
								type: 'string',
							},
							{
								inputId: '03-03-05-03',
								identifier: 'AMOUNT',
								label: 'Cantidad',
								caption: 'De esta especie',
								placeholder: 'Número de árboles',
								type: 'number',
							},
							{
								inputId: '03-03-05-04',
								identifier: 'EXTRA',
								label: 'Comentarios extra',
								caption: '',
								placeholder:
									'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
								type: 'textarea',
							},
						],
					},
					{
						step2typeId: '03-03-06',
						identifier: 'PALMS',
						label: 'Palmeras',
						subLabel: '',
						question: 'Completa toda la información que puedas',
						inputs: [
							{
								inputId: '03-03-06-01',
								identifier: 'SPECIE',
								label: 'Especie',
								caption: 'Si la sabes',
								placeholder: 'Especie de la palmera',
								type: 'string',
							},
							{
								inputId: '03-03-06-02',
								identifier: 'HEIGTH',
								label: 'Altura',
								caption: 'Altura media en metros',
								placeholder: 'Altura media de las palmeras',
								type: 'string',
							},
							{
								inputId: '03-03-06-03',
								identifier: 'AMOUNT',
								label: 'Cantidad',
								caption: 'De este tipo',
								placeholder: 'Número de palmeras',
								type: 'number',
							},
							{
								inputId: '03-03-06-04',
								identifier: 'EXTRA',
								label: 'Comentarios extra',
								caption: '',
								placeholder:
									'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
								type: 'textarea',
							},
						],
					},
				],
			},
			{
				step1typeId: '03-04',
				identifier: 'IRRIGATION_SYSTEM',
				label: 'Sistema de riego',
				subLabel: '',
				question: '¿Problemas con el sistema de riego?',
				step2types: [
					{
						step2typeId: '03-04-01',
						identifier: 'FILTERS',
						label: 'Filtros',
						subLabel: '',
						question: '¿Qué necesitas hacer en los filtros?',
						step3types: [
							{
								step3typeId: '03-04-01-01',
								identifier: 'CLEAN',
								label: 'Limpiar',
								subLabel: '',
								question: 'Detalles de los filtros',
								inputs: [
									{
										inputId: '03-04-01-01-01',
										identifier: 'EXTRA',
										label: 'Comentarios extra',
										caption: '',
										placeholder:
											'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
										type: 'textarea',
									},
									{
										inputId: '03-04-01-01-02',
										identifier: 'AMOUNT',
										label: 'Cantidad',
										caption: 'De este tipo de filtros',
										placeholder: 'Número de filtros a limpiar',
										type: 'number',
									},
								],
							},
							{
								step3typeId: '03-04-01-02',
								identifier: 'CHANGE',
								label: 'Cambiar',
								subLabel: '',
								question: 'Detalles de los filtros',
								inputs: [
									{
										inputId: '03-04-01-02-01',
										identifier: 'EXTRA',
										label: 'Comentarios extra',
										caption: '',
										placeholder:
											'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
										type: 'textarea',
									},
									{
										inputId: '03-04-01-02-02',
										identifier: 'AMOUNT',
										label: 'Cantidad',
										caption: 'De este tipo de filtros',
										placeholder: 'Número de filtros a cambiar',
										type: 'number',
									},
								],
							},
						],
					},
					{
						step2typeId: '03-04-02',
						identifier: 'LEAKS',
						label: 'Fugas',
						subLabel: '',
						question: 'Detalles de las fugas',
						inputs: [
							{
								inputId: '03-04-02-01',
								identifier: 'EXTRA',
								label: 'Comentarios extra',
								caption: '',
								placeholder:
									'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
								type: 'textarea',
							},
							{
								inputId: '03-04-02-02',
								identifier: 'AMOUNT',
								label: 'Cantidad',
								caption: 'De fugas detectadas',
								placeholder: 'Número de fugas detectadas',
								type: 'number',
							},
						],
					},
					{
						step2typeId: '03-04-03',
						identifier: 'SPRINKLERS',
						label: 'Aspersores',
						subLabel: '',
						question: '¿Qué necesitas hacer a tus aspersores?',
						step3types: [
							{
								step3typeId: '03-04-03-01',
								identifier: 'ADJUST',
								label: 'Ajustar',
								subLabel: '',
								question: 'Detalles de los aspersores',
								inputs: [
									{
										inputId: '03-04-03-01-01',
										identifier: 'EXTRA',
										label: 'Comentarios extra',
										caption: '',
										placeholder:
											'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
										type: 'textarea',
									},
									{
										inputId: '03-04-03-01-02',
										identifier: 'AMOUNT',
										label: 'Cantidad',
										caption: 'De aspersores a ajustar',
										placeholder: 'Número de aspersores a ajustar',
										type: 'number',
									},
								],
							},
							{
								step3typeId: '03-04-03-02',
								identifier: 'CHANGE',
								label: 'Cambiar',
								subLabel: '',
								question: 'Detalles de los aspersores',
								inputs: [
									{
										inputId: '03-04-03-02-01',
										identifier: 'EXTRA',
										label: 'Comentarios extra',
										caption: '',
										placeholder:
											'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
										type: 'textarea',
									},
									{
										inputId: '03-04-03-02-02',
										identifier: 'AMOUNT',
										label: 'Cantidad',
										caption: 'De aspersores a cambiar',
										placeholder: 'Número de aspersores a cambiar',
										type: 'number',
									},
								],
							},
						],
					},
					{
						step2typeId: '03-04-04',
						identifier: 'DRIP',
						label: 'Goteo',
						subLabel: '',
						question: '¿Qué necesitas hacer en el sistema de goteo?',
						step3types: [
							{
								step3typeId: '03-04-04-01',
								identifier: 'UNCLOG',
								label: 'Desobstruir',
								subLabel: '',
								question: 'Detalles de las obstrucciones',
								inputs: [
									{
										inputId: '03-04-04-01-01',
										identifier: 'EXTRA',
										label: 'Comentarios extra',
										caption: '',
										placeholder:
											'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
										type: 'textarea',
									},
									{
										inputId: '03-04-04-01-02',
										identifier: 'AMOUNT',
										label: 'Cantidad',
										caption: 'De obstrucciones detectadas',
										placeholder: 'Número de obstrucciones detectadas',
										type: 'number',
									},
								],
							},
							{
								step3typeId: '03-04-04-02',
								identifier: 'CHANGE',
								label: 'Cambiar',
								subLabel: 'Tramos de la goma',
								question: 'Detalles de los tramos de goteo',
								inputs: [
									{
										inputId: '03-04-04-02-01',
										identifier: 'EXTRA',
										label: 'Comentarios extra',
										caption: '',
										placeholder:
											'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
										type: 'textarea',
									},
									{
										inputId: '03-04-04-02-02',
										identifier: 'AMOUNT',
										label: 'Cantidad',
										caption: 'De tramos a cambiar',
										placeholder: 'Número de tramos a cambiar',
										type: 'number',
									},
								],
							},
							{
								step3typeId: '03-04-04-03',
								identifier: 'REPAIR',
								label: 'Reparar roturas',
								subLabel: '',
								question: 'Detalles de la rotura',
								inputs: [
									{
										inputId: '03-04-04-03-01',
										identifier: 'EXTRA',
										label: 'Comentarios extra',
										caption: '',
										placeholder:
											'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
										type: 'textarea',
									},
									{
										inputId: '03-04-04-03-02',
										identifier: 'AMOUNT',
										label: 'Cantidad',
										caption: 'De roturas detectadas',
										placeholder: 'Número de roturas detectadas',
										type: 'number',
									},
								],
							},
						],
					},
					{
						step2typeId: '03-04-05',
						identifier: 'PIPELINES',
						label: 'Tuberías',
						subLabel: '',
						question: '¿Qué necesitas hacer en el sistema de tuberías?',
						step3types: [
							{
								step3typeId: '03-04-05-01',
								identifier: 'UNCLOG',
								label: 'Desobstruir',
								subLabel: '',
								question: 'Detalles de las obstrucciones',
								inputs: [
									{
										inputId: '03-04-05-01-01',
										identifier: 'EXTRA',
										label: 'Comentarios extra',
										caption: '',
										placeholder:
											'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
										type: 'textarea',
									},
									{
										inputId: '03-04-05-01-02',
										identifier: 'AMOUNT',
										label: 'Cantidad',
										caption: 'De obstrucciones detectadas',
										placeholder: 'Número de obstrucciones detectadas',
										type: 'number',
									},
								],
							},
							{
								step3typeId: '03-04-05-02',
								identifier: 'CHANGE',
								label: 'Cambiar',
								subLabel: 'Tramos de tubería',
								question: 'Detalles de los tramos de tubería',
								inputs: [
									{
										inputId: '03-04-05-02-01',
										identifier: 'EXTRA',
										label: 'Comentarios extra',
										caption: '',
										placeholder:
											'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
										type: 'textarea',
									},
									{
										inputId: '03-04-05-02-02',
										identifier: 'AMOUNT',
										label: 'Cantidad',
										caption: 'De tramos a cambiar',
										placeholder: 'Número de tramos a cambiar',
										type: 'number',
									},
								],
							},
							{
								step3typeId: '03-04-05-03',
								identifier: 'REPAIR',
								label: 'Reparar roturas',
								subLabel: '',
								question: 'Detalles de la rotura',
								inputs: [
									{
										inputId: '03-04-05-03-01',
										identifier: 'EXTRA',
										label: 'Comentarios extra',
										caption: '',
										placeholder:
											'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
										type: 'textarea',
									},
									{
										inputId: '03-04-05-03-02',
										identifier: 'AMOUNT',
										label: 'Cantidad',
										caption: 'De roturas detectadas',
										placeholder: 'Número de roturas detectadas',
										type: 'number',
									},
								],
							},
						],
					},
					{
						step2typeId: '03-04-06',
						identifier: 'PROGRAMMER',
						label: 'Programador',
						subLabel: '',
						question: '¿Qué problema tienes en el programador?',
						inputs: [
							{
								inputId: '03-04-06-01',
								identifier: 'EXTRA',
								label: 'Comentarios extra',
								caption: '',
								placeholder:
									'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
								type: 'textarea',
							},
						],
					},
					{
						step2typeId: '03-04-07',
						identifier: 'SOLENOID_VALVES',
						label: 'Electroválvulas',
						subLabel: '',
						question: '¿Qué problema tienes en las electroválvulas?',
						inputs: [
							{
								inputId: '03-04-07-01',
								identifier: 'EXTRA',
								label: 'Comentarios extra',
								caption: '',
								placeholder:
									'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
								type: 'textarea',
							},
						],
					},
				],
			},
			{
				step1typeId: '03-05',
				identifier: 'TREATMENT',
				label: 'Tratamientos',
				subLabel: '',
				question: '¿Qué necesitas?',
				step2types: [
					{
						step2typeId: '03-05-01',
						identifier: 'FERTILIZE',
						label: 'Abonar',
						subLabel: '',
						question: '¿Qué quieres abonar?',
						step3types: [
							{
								step3typeId: '03-05-01',
								identifier: 'ORNAMENTAL_PLANTS',
								label: 'Ornamentales',
								subLabel: 'Crecimiento y floración',
								question: 'Completa toda la información que puedas',
								inputs: [
									{
										inputId: '03-05-01-01',
										identifier: 'SPECIE',
										label: 'Especie',
										caption: 'Si la sabes',
										placeholder: 'Especie de la planta',
										type: 'string',
									},
									{
										inputId: '03-05-01-02',
										identifier: 'AMOUNT',
										label: 'Cantidad',
										caption: 'De esta especie',
										placeholder: 'Número de plantas',
										type: 'number',
									},
									{
										inputId: '03-05-01-03',
										identifier: 'EXTRA',
										label: 'Comentarios extra',
										caption: '',
										placeholder:
											'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
										type: 'textarea',
									},
								],
							},
							{
								step3typeId: '03-05-02',
								identifier: 'GRASS',
								label: 'Césped',
								subLabel: 'Crecimiento',
								question: 'Completa toda la información que puedas',
								inputs: [
									{
										inputId: '03-05-02-01',
										identifier: 'SPECIE',
										label: 'Tipo / Especie',
										caption: 'Si lo sabes',
										placeholder: 'Especie del cesped',
										type: 'string',
									},
									{
										inputId: '03-05-02-02',
										identifier: 'AREA',
										label: 'Superficie a abonar',
										caption: 'En m2. Aproximadamente.',
										placeholder: 'Superficie a abonar',
										type: 'number',
									},
									{
										inputId: '03-05-02-03',
										identifier: 'EXTRA',
										label: 'Comentarios extra',
										caption: '',
										placeholder:
											'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
										type: 'textarea',
									},
								],
							},
							{
								step3typeId: '03-05-03',
								identifier: 'HEDGES',
								label: 'Setos',
								subLabel: 'Floración',
								question: 'Completa toda la información que puedas',
								inputs: [
									{
										inputId: '03-05-03-01',
										identifier: 'TYPE',
										label: 'Tipo',
										caption: 'Si lo sabes',
										placeholder: 'Lineal / De valla',
										type: 'string',
									},
									{
										inputId: '03-05-03-02',
										identifier: 'SPECIE',
										label: 'Especie',
										caption: 'Si la sabes',
										placeholder: 'Especie del seto',
										type: 'string',
									},
									{
										inputId: '03-05-03-03',
										identifier: 'DIMENSIONS',
										label: 'Dimensiones',
										caption: 'Ancho x Alto x Largo en metros aprox.',
										placeholder: 'Dimensiones del seto',
										type: 'string',
									},
									{
										inputId: '03-05-03-04',
										identifier: 'EXTRA',
										label: 'Comentarios extra',
										caption: '',
										placeholder:
											'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
										type: 'textarea',
									},
								],
							},
							{
								step3typeId: '03-05-04',
								identifier: 'ARBUSTOS',
								label: 'Arbustos',
								subLabel: 'Floración',
								question: 'Completa toda la información que puedas',
								inputs: [
									{
										inputId: '03-05-04-01',
										identifier: 'SPECIE',
										label: 'Especie',
										caption: 'Si la sabes',
										placeholder: 'Especie del arbusto',
										type: 'string',
									},
									{
										inputId: '03-05-04-02',
										identifier: 'AMOUNT',
										label: 'Cantidad',
										caption: 'De esta especie',
										placeholder: 'Número de arbustos',
										type: 'number',
									},
									{
										inputId: '03-05-04-03',
										identifier: 'EXTRA',
										label: 'Comentarios extra',
										caption: '',
										placeholder:
											'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
										type: 'textarea',
									},
								],
							},
							{
								step3typeId: '03-05-05',
								identifier: 'TREES',
								label: 'Árboles',
								subLabel: 'Floración',
								question: 'Completa toda la información que puedas',
								inputs: [
									{
										inputId: '03-05-05-01',
										identifier: 'SPECIE',
										label: 'Especie',
										caption: 'Si la sabes',
										placeholder: 'Especie del árbol',
										type: 'string',
									},
									{
										inputId: '03-05-06-02',
										identifier: 'HEIGTH',
										label: 'Altura',
										caption: 'Altura media en metros',
										placeholder: 'Altura media de los arboles',
										type: 'string',
									},
									{
										inputId: '03-05-05-03',
										identifier: 'AMOUNT',
										label: 'Cantidad',
										caption: 'De esta especie',
										placeholder: 'Número de árboles',
										type: 'number',
									},
									{
										inputId: '03-05-05-04',
										identifier: 'EXTRA',
										label: 'Comentarios extra',
										caption: '',
										placeholder:
											'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
										type: 'textarea',
									},
								],
							},
							{
								step3typeId: '03-05-06',
								identifier: 'PALMS',
								label: 'Palmeras',
								subLabel: 'Crecimiento',
								question: 'Completa toda la información que puedas',
								inputs: [
									{
										inputId: '03-05-06-01',
										identifier: 'SPECIE',
										label: 'Especie',
										caption: 'Si la sabes',
										placeholder: 'Especie de la palmera',
										type: 'string',
									},
									{
										inputId: '03-05-06-02',
										identifier: 'HEIGTH',
										label: 'Altura',
										caption: 'Altura media en metros',
										placeholder: 'Altura media de las palmeras',
										type: 'string',
									},
									{
										inputId: '03-05-06-03',
										identifier: 'AMOUNT',
										label: 'Cantidad',
										caption: 'De este tipo',
										placeholder: 'Número de palmeras',
										type: 'number',
									},
									{
										inputId: '03-05-06-04',
										identifier: 'EXTRA',
										label: 'Comentarios extra',
										caption: '',
										placeholder:
											'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
										type: 'textarea',
									},
								],
							},
						],
					},
					{
						step2typeId: '03-05-02',
						identifier: 'PHYTOSANITARY',
						label: 'Fitosanitarios',
						subLabel: '',
						question: '¿Qué necesitas?',
						step3types: [
							{
								step3typeId: '02-05-02-01',
								identifier: 'PLAGUES_AND_DISEASES',
								label: 'Plagas y enfermedades',
								subLabel: '',
								question: 'Detalles de la plaga o la enfermedad',
								inputs: [
									{
										inputId: '02-05-02-01-01',
										identifier: 'EXTRA',
										label: 'Comentarios extra',
										caption: '',
										placeholder:
											'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
										type: 'textarea',
									},
								],
							},
							{
								step3typeId: '02-05-02-02',
								identifier: 'HERBICIDES_AND_WEEDS',
								label: 'Hervicidas y malas hierbas',
								subLabel: '',
								question: '¿Qué malas hierbas necesitas eliminar?',
								inputs: [
									{
										inputId: '02-05-02-02-01',
										identifier: 'EXTRA',
										label: 'Comentarios extra',
										caption: '',
										placeholder:
											'¡Cualquier comentario extra para saber mejor qué necesitas es bienvenido!',
										type: 'textarea',
									},
								],
							},
						],
					},
				],
			},
		],
	},
];
